import modalBox from '@/components/form-modal/modal-tools';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import ls from '@/utils/local-storage';
import { reactive } from 'vue';
import { message, Modal, notification } from 'ant-design-vue';
import {
  create_c_z_record,
  create_card_record,
  create_order_record,
  get_card_by_id,
  get_customer_wallet_fl_rate,
  get_project_by_id,
} from '@/api/mjstore-model';
import bus from '@/utils/bus';
import { calculate_cz_price, calculate_fl_price } from '@/components/utils/tools';
const event_bus = bus;
const router = useRouter();
export const btn_record = {
  cb: (customer_id: number) => {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    return new Promise(resolve => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '充值',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [5, 5],
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'customer_id',
              label: '会员姓名',
              disabled: true,
              placeholder: '请选择会员姓名',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-customer',
            },
            {
              type: 'input',
              name: 'price',
              label: '收款金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写收款金额',
            },
            {
              type: 'input',
              name: 'cz_flje',
              label: '返利金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写返利金额',
            },
            {
              type: 'remoteselect',
              name: 'sk_type_id',
              label: '收款方式',
              disabled: false,
              placeholder: '请选择收款方式',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-sktype',
            },
            {
              type: 'remoteselect',
              name: 'cxzc_id',
              label: '促销政策',
              disabled: false,
              placeholder: '请选择促销政策',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-policy',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '充值日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择充值日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'remoteselect',
              name: 'doctor_ids',
              label: '治疗师',
              disabled: false,
              placeholder: '请选择治疗师',
              datasourceType: 'remote',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'input',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            customer_id: [{ required: true, message: '请填输入会员姓名' }],
            price: [{ required: true, message: '请填输入收款金额' }],
            cz_flje: [{ required: true, message: '请填输入返利金额' }],
            sk_type_id: [{ required: true, message: '请填输入收款方式' }],
            cxzc_id: [{ required: true, message: '请填输入促销政策' }],
            date: [{ required: true, message: '请填输入充值日期' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请填输入执行门店' }],
            doctor_ids: [{ required: true, message: '请选择治疗师' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            customer_id: customer_id,
            price: null,
            cz_flje: null,
            sk_type_id: null,
            cxzc_id: null,
            staff_id: null,
            doctor_ids: null,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            mark: null,
            shop_id: current_shop?.id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          editModal.loading = true;
          create_c_z_record(payload)
            .then(() => {
              message.success('充值成功');
              resolve(null);
            })
            .finally(() => {
              editModal.loading = false;
            });
        },
      });
      modalBox(editModal);
    });
  },
};
export const btn_record2 = {
  name: '新建套餐购买记录',
  clazz: 'primary',
  cb: (params: any) => {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const modifyModal: any = reactive({
      visible: false,
      component: 'Setrecordmodel',
      obj: {
        org_id: current_org?.id,
        name: '',
        price: '',
        project_type_id: '',
        card_ids: [],
        project_ids: [],
        disabled: true,
        ...params,
      },
    });

    modifyModal.visible = true;
    modifyModal.ok = () => {
      event_bus.emit('refresh_basic');
      event_bus.emit('refresh_custom_info', params.customer_id);
    };
    modifyModal.cancel = () => {};
    modalBox(modifyModal);
  },
};
import moment from 'moment';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import {useRouter} from "vue-router";
export const btn_record3 = {
  cb: (data: any) => {
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const project_ids: Array<number> = reactive([]);
    const formModel = reactive({
      org_id: current_org?.id,
      is_active: true,
      num: 0,
      zjfl: 0,
      zjje: 0,
      date: moment().format('YYYY-MM-DD HH:mm'),
      total_num: 1,
      project_id: project_ids,
      customer_id: data.customer_id,
      shop_id: current_shop?.id,
      fl_rate: null,
      cz_rate: 1,
    });
    if (data.customer_id > 0) {
      get_customer_wallet_fl_rate({
        org_id: current_org.id,
        customer_id: Number(data.customer_id),
      }).then((res: any) => {
        formModel.fl_rate = res.fl_rate;
        formModel.cz_rate = 1 - res.fl_rate;
      });
    }
    const editModal = reactive({
      visible: true,
      loading: false,
      title: '下单',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          col: [7, 7],
        },
        fields: [
          {
            type: 'remotemodal',
            name: 'customer_id',
            label: '会员姓名',
            disabled: true,
            placeholder: '请选择会员姓名',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-customer',
          },
          {
            type: 'remotemodal',
            name: 'project_id',
            label: '项目名称',
            disabled: false,
            placeholder: '请选择项目名称',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-project',
          },
          {
            type: 'number',
            name: 'total_num',
            label: '项目次数',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            min: 1,
            placeholder: '请填写项目次数',
          },
          {
            type: 'number',
            name: 'total_price',
            label: '项目单价',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写项目单价',
          },
          {
            type: 'number',
            name: 'price',
            label: '项目金额',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写项目单价',
          },
          {
            type: 'number',
            name: 'czje',
            label: '充值使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写充值使用金额',
          },
          {
            type: 'number',
            name: 'flje',
            label: '返利使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写返利使用金额',
          },
          {
            type: 'number',
            name: 'zjfl',
            label: '直接返利',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写直接返利',
          },
          {
            type: 'number',
            name: 'zjje',
            label: '赠券使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写赠券使用金额',
          },

          {
            type: 'remoteselect',
            name: 'cxzc_id',
            label: '促销政策',
            disabled: false,
            placeholder: '请选择促销政策',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-policy',
          },
          {
            type: 'datepicker',
            name: 'date',
            label: '下单日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD HH:mm',
            valueFormat: 'YYYY-MM-DD HH:mm',
            showTime: true,
            placeholder: '请填写下单时间',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '门店列表',
            disabled: !!current_shop,
            placeholder: '请选择门店列表',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-querystaffselectlist',
          },
          {
            type: 'input',
            name: 'mark',
            label: '备注',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写备注',
          },
        ],
        rules: {
          customer_id: [{ required: true, message: '请选会员姓名' }],
          czje: [{ required: true, message: '请填写充值使用金额' }],
          flje: [{ required: true, message: '请填写返利使用金额' }],
          zjfl: [{ required: true, message: '请填写直接返利' }],
          zjje: [{ required: true, message: '请填写赠券使用金额' }],
          date: [{ required: true, message: '请填写下单日期' }],
          shop_id: [{ required: true, message: '请选执行门店' }],
          staff_id: [{ required: true, message: '请选执行人' }],
          total_num: [{ required: true, message: '请填写项目次数' }],
          cxzc_id: [{ required: true, message: '请选择促销政策' }],
        },
        model: formModel,
        watch: {
          project_id: (data: any) => {
            if (data.project_id > 0) {
              get_project_by_id({
                org_id: current_org.id,
                project_id: Number(data.project_id),
              }).then((res: any) => {
                console.log('res', res);
                data['total_price'] = res.price;
                if (Number(data.total_price) >= 0) {
                  data['price'] = Number(data.total_num) * Number(data.total_price);
                }
                data['czje'] = calculate_cz_price(data, formModel.cz_rate);
                data['flje'] = calculate_fl_price(data);
              });
            }
          },
          total_num: (data: any) => {
            if (Number(data.total_price) >= 0) {
              data['price'] = Number(data.total_num) * Number(data.total_price);
            }
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          total_price: (data: any) => {
            if (Number(data.total_price) >= 0) {
              data['price'] = Number(data.total_num) * Number(data.total_price);
            }
          },
          zjfl: (data: any) => {
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          zjje: (data: any) => {
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          customer_id: (data: any) => {
            get_customer_wallet_fl_rate({
              org_id: current_org.id,
              customer_id: Number(data.customer_id),
            }).then((res: any) => {
              //   data['fl_rate'] = res.fl_rate;
              formModel.cz_rate = 1 - res.fl_rate;
            });
          },
        },
      },
      options: {},
      ok: (data: any) => {
        const event_bus = bus;
        return new Promise(function (resolve) {
          if (
            Number(data.czje) + Number(data.flje) + Number(data.zjfl) + Number(data.zjje) !=
            Number(data.price)
          ) {
            notification.error({
              message: '金额输入错误',
              description:
                '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】+【赠券使用金额】',
            });
            return false;
          }
          editModal.loading = true;
          create_order_record({ ...data, org_id: current_org?.id })
            .then((res: any) => {
              if (res.is_confirm) {
                Modal.confirm({
                  title: '提示',
                  content: res.message,
                  onOk() {
                    return new Promise(resolve1 => {
                      create_order_record({
                        ...data,
                        org_id: current_org?.id,
                        is_confirm: true,
                      })
                        .then(function () {
                          message.success('创建成功');
                          event_bus.emit('refresh_basic');
                          event_bus.emit('refresh_custom_info', data.customer_id);
                          resolve(null);
                        })
                        .finally(() => {
                          resolve1(null);
                          editModal.loading = false;
                        });
                    });
                  },
                  onCancel() {},
                });
              } else {
                message.success('创建成功');
                event_bus.emit('refresh_basic');
                event_bus.emit('refresh_custom_info', data.customer_id);
                resolve(null);
              }
            })
            .finally(() => {
              editModal.loading = false;
            });
        });
      },
    });
    modalBox(editModal);
  },
};
export const btn_record4 = {
  cb: (data: any) => {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const formModel = reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      customer_id: data.customer_id,
      card_id: null,
      total_num: 1,
      single_price: null,
      price: null,
      zjfl: 0,
      zjje: 0,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
      cxzc_id: null,
      shop_id: current_shop?.id,
      staff_id: null,
      fl_rate: null,
      cz_rate: 1,
    });
    if (data.customer_id > 0) {
      get_customer_wallet_fl_rate({
        org_id: current_org.id,
        customer_id: Number(data.customer_id),
      }).then((res: any) => {
        formModel.fl_rate = res.fl_rate;
        formModel.cz_rate = 1 - res.fl_rate;
      });
    }
    const editModal = reactive({
      visible: true,
      loading: false,
      title: '购卡',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          col: [7, 7],
          labelCol: {
            span: 8,
          },
          wrapperCol: {
            span: 16,
          },
        },
        fields: [
          {
            type: 'remotemodal',
            name: 'customer_id',
            label: '会员姓名',
            disabled: true,
            placeholder: '请选择会员姓名',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-customer',
          },
          {
            type: 'remotemodal',
            name: 'card_id',
            label: '卡',
            disabled: false,
            placeholder: '请选择卡',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-card',
          },
          {
            type: 'number',
            name: 'total_num',
            label: '项目次数',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            min: 1,
            placeholder: '请填写项目次数',
          },
          {
            type: 'number',
            name: 'single_price',
            label: '项目单价',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写单价',
          },
          {
            type: 'number',
            name: 'price',
            label: '项目金额',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写总价',
          },
          {
            type: 'number',
            name: 'czje',
            label: '充值使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写充值使用金额',
          },
          {
            type: 'number',
            name: 'flje',
            label: '返利使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写返利使用金额',
          },
          {
            type: 'number',
            name: 'zjfl',
            label: '直接返利',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写直接返利',
          },
          {
            type: 'number',
            name: 'zjje',
            label: '赠券使用金额',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写赠券使用金额',
          },
          {
            type: 'datepicker',
            name: 'date',
            label: '购卡日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            showTime: true,
            placeholder: '请选择购卡日期',
          },
          {
            type: 'remoteselect',
            name: 'cxzc_id',
            label: '促销政策',
            disabled: false,
            placeholder: '请选择促销政策',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-policy',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '执行门店',
            disabled: !!current_shop,
            placeholder: '请选择执行门店',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-staff',
          },
          {
            type: 'input',
            name: 'mark',
            label: '备注',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写备注',
          },
        ],
        rules: {
          customer_id: [{ required: true, message: '请填输入会员姓名' }],
          card_id: [{ required: true, message: '请填输入卡' }],
          date: [
            { required: true, message: '请填输入购卡日期' },
            {
              validator: async (rule: RuleObject, value: string) => {
                if (moment(value) > moment()) {
                  return Promise.reject('不能选择大于当前日期的时间');
                } else {
                  return Promise.resolve();
                }
              },
              trigger: 'change',
            },
          ],
          shop_id: [{ required: true, message: '请填输入执行门店' }],
          staff_id: [{ required: true, message: '请选执行人' }],
          czje: [{ required: true, message: '请填写充值使用金额' }],
          flje: [{ required: true, message: '请填写返利使用金额' }],
          zjfl: [{ required: true, message: '请填写直接返利' }],
          zjje: [{ required: true, message: '请填写赠券使用金额' }],
          total_num: [{ required: true, message: '请填写卡次数' }],
          cxzc_id: [{ required: true, message: '请选择促销政策' }],
        },
        model: formModel,
        watch: {
          single_price: (data: any) => {
            data.price = Number((data.single_price * data.total_num).toFixed(0));
          },
          total_num: (data: any) => {
            data.price = Number((data.single_price * data.total_num).toFixed(0));
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          card_id: (data: any, form: any) => {
            if (data['card_id'] > 0) {
              get_card_by_id({
                org_id: current_org.id,
                card_id: Number(data.card_id),
              }).then((res: any) => {
                if (res) {
                  // is_disable_total_num.value = true;
                  data.single_price = res.price;

                  const f = form.fields.find((item: any) => {
                    return item.name == 'total_num';
                  });
                  if (f) {
                    f.disabled = res.card_type == 11;
                    if (res.card_type == 11) {
                      data.total_num = res.max_num;
                    }
                  }
                  if (Number(data.single_price) >= 0) {
                    data.price = Number((data.single_price * data.total_num).toFixed(0));
                  }
                  debugger;
                  data['czje'] = calculate_cz_price(data, formModel.cz_rate);
                  data['flje'] = calculate_fl_price(data);
                }
              });
            }
          },
          zjfl: (data: any) => {
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          zjje: (data: any) => {
            data['czje'] = calculate_cz_price(data, formModel.cz_rate);
            data['flje'] = calculate_fl_price(data);
          },
          customer_id: (data: any) => {
            get_customer_wallet_fl_rate({
              org_id: current_org.id,
              customer_id: Number(data.customer_id),
            }).then((res: any) => {
              //   data['fl_rate'] = res.fl_rate;
              formModel.cz_rate = 1 - res.fl_rate;
            });
          },
        },
      },
      options: {},
      ok: (modeldata: any) => {
        const event_bus = bus;
        const p = new Promise(function (resolve) {
          if (
            (
              Number(modeldata.czje) +
              Number(modeldata.flje) +
              Number(modeldata.zjfl) +
              Number(modeldata.zjje)
            ).toFixed(0) != Number(modeldata.price).toFixed(0)
          ) {
            notification.error({
              message: '金额输入错误',
              description:
                '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】+【赠券使用金额】',
            });
            return false;
          }
          editModal.loading = true;
          create_card_record({ ...modeldata, org_id: current_org?.id })
            .then((res: any) => {
              if (res.is_confirm) {
                Modal.confirm({
                  title: '提示',
                  content: res.message,
                  onOk() {
                    create_card_record({
                      ...modeldata,
                      org_id: current_org?.id,
                      is_confirm: true,
                    }).then(function () {
                      message.success('创建成功');
                      event_bus.emit('refresh_basic');
                      event_bus.emit('refresh_custom_info', data.customer_id);
                      resolve(null);
                    });
                  },
                  onCancel() {},
                });
              } else {
                message.success('创建成功');
                event_bus.emit('refresh_basic');
                event_bus.emit('refresh_custom_info', data.customer_id);
                resolve(null);
              }
            })
            .finally(() => {
              editModal.loading = false;
            });
        });
        return p;
      },
    });
    modalBox(editModal);
  },
};

export const btn_record5 = {
  cb: (data: any) => {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const modifyModal: any = reactive({
      visible: false,
      component: 'Receiptrecordmodel',
      obj: {
        org_id: current_org?.id,
        ...data,
      },
    });

    modifyModal.visible = true;
    modifyModal.ok = () => {
      event_bus.emit('refresh_basic');
      event_bus.emit('refresh_custom_info', data.customer_id);
    };
    modifyModal.cancel = () => {};
    modalBox(modifyModal);
  },
};
export const btn_record6 = {
  cb: (data: any) => {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const modifyModal: any = reactive({
      visible: false,
      component: 'Printcustomerremainmodel',
      obj: {
        org_id: current_org?.id,
        ...data,
      },
    });

    modifyModal.visible = true;
    modifyModal.ok = () => {
      event_bus.emit('refresh_basic');
      event_bus.emit('refresh_custom_info', data.customer_id);
    };
    modifyModal.cancel = () => {};
    modalBox(modifyModal);
  },
};
